import waitUntil from 'async-wait-until';
import { closest, toggleClass, hasClass } from '@utils/domUtils';
import { post } from '@utils/request';

/* global ACTION_ROUTES */

export default class JobBoostingSelector {
  static selectorString() {
    return '.JobBoostingSelector';
  }

  async render(node, props) {
    this.jobId = props['job-id'];
    this.basket = node.querySelector('.JobBoostingSelectorBasket');

    await waitUntil(() => this.basket.component);

    [...node.querySelectorAll('.JobBoostingChannelCard .button-toggle-selection')].forEach(
      element => {
        element.jobBoostingChannelCard = closest(element, '.JobBoostingChannelCard');
        element.addEventListener('click', this.selectPublishChannel.bind(this));
      },
    );
  }

  selectPublishChannel(event) {
    event.preventDefault();

    const element = event.currentTarget.jobBoostingChannelCard;

    if (element.getAttribute('data-locked') === 'true') {
      return false;
    }

    element.setAttribute('data-locked', 'true');
    toggleClass(element, 'selected');

    const isSelected = hasClass(element, 'selected');

    const channelId = element.getAttribute('data-id');
    const channelType = element.getAttribute('data-type');

    if (channelId && !isNaN(this.jobId)) {
      post({
        url: getActionRoute(channelType, isSelected),
        data: {
          jobId: this.jobId,
          channelId: channelId,
        },
        success: data => {
          element.removeAttribute('data-locked');
          this.updateBasket(data);
        },
        error: () => element.removeAttribute('data-locked'),
      });
    }
  }

  updateBasket(data) {
    this.basket.component.updateBasket(data);
  }
}

function getActionRoute(channelType, isSelected) {
  if (channelType === 'vonq_campaign') {
    return isSelected
      ? ACTION_ROUTES.ADD_VONQ_CHANNEL_TO_BASKET
      : ACTION_ROUTES.REMOVE_VONQ_CHANNEL_FROM_BASKET;
  }

  return isSelected
    ? ACTION_ROUTES.ADD_CHANNEL_TO_BASKET
    : ACTION_ROUTES.REMOVE_CHANNEL_FROM_BASKET;
}
